module.exports = __webpack_public_path__ + "static/seedstarting-025231fbbc716ea51c82ed7276520981.jpg";